import React, { useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import StatePositionConstant from "./StatePositionConstant";

export default function ReportPosition() {
  const [reportPosition, setReportPosition] = useState(null);
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  const generateReportPositionCampaignActive = () => {
    let campaignIDSActive = reportPosition.campaign_IDS_active;
    return (
      <>
        <hr />
        <h4 className="text text-danger">
          کمپین های در حالت فعال برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSActive.map((item, index) => {
              return (
                <tr>
                  <td>{helperNumbers.toPersianNum(index + 1)}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignPending = () => {
    let campaignIDSPending = reportPosition.campaign_IDS_pending;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های در حال انتظار برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSPending.map((item, index) => {
              return (
                <tr>
                  <td>{helperNumbers.toPersianNum(index + 1)}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignActiveAlternative = () => {
    let campaignIDSPending = reportPosition.campaign_IDS_active_alternative;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های جایگزین فعال برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSPending.map((item, index) => {
              return (
                <tr>
                  <td>{helperNumbers.toPersianNum(index + 1)}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignPendingAlternative = () => {
    let campaignIDSPendingAlternative =
      reportPosition.campaign_IDS_pending_alternative;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های جایگزین در حال انتظار برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSPendingAlternative.map((item, index) => {
              return (
                <tr>
                  <td>{helperNumbers.toPersianNum(index + 1)}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const getBadgeTypeClassStatePosition = (statePosition) => {
    let classNameBadgeType;
    switch (statePosition) {
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.PENDING
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.SEND_SUGGESTION_TO_PUBLISHER
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.DISAGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.AGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "primary";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.CONFIRM
      ]:
        classNameBadgeType = "success";
        break;

      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.ALREADY_CONFIRMED_PENDING_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "primary";
        break;
    }
    return classNameBadgeType;
  };

  const generateTagHtmlReportPosition = () => {
    return (
      <div>
        <div>
          {reportPosition.campaign_IDS_active.length !== 0 ? (
            generateReportPositionCampaignActive()
          ) : (
            <p className="alert alert-primary">
              این جایگاه هیچ کمپین در حالت فعال ندارد
            </p>
          )}
        </div>
        <div>
          {reportPosition.campaign_IDS_pending.length !== 0 ? (
            generateReportPositionCampaignPending()
          ) : (
            <p className="alert alert-primary">
              این جایگاه هیچ کمپین در حالت انتظار ندارد
            </p>
          )}
        </div>
        <div>
          {reportPosition.campaign_IDS_active_alternative.length !== 0 ? (
            generateReportPositionCampaignActiveAlternative()
          ) : (
            <p className="alert alert-primary">
              این جایگاه هیچ کمپین جایگزین در حالت فعال ندارد{" "}
            </p>
          )}
        </div>
        <div>
          {reportPosition.campaign_IDS_pending_alternative.length !== 0 ? (
            generateReportPositionCampaignPendingAlternative()
          ) : (
            <p className="alert alert-primary">
              این جایگاه هیچ کمپین جایگزین در حالت انتظار ندارد
            </p>
          )}
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات جایگاه
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره جایگاه</td>
                <td>{helperNumbers.toPersianNum(reportPosition.id)}</td>
              </tr>
              <tr>
                <td>شماره صفحه</td>
                <td>
                  {reportPosition.page_id == 0
                    ? "مستقل"
                    : helperNumbers.toPersianNum(reportPosition.page_id)}
                </td>
              </tr>
              <tr>
                <td>آدرس صفحه</td>
                <td dir="ltr" className="text-left ">
                  <span className="pr-2">{reportPosition.website_url}</span>
                  <a
                    target="_blank"
                    className="btn btn-primary"
                    href={reportPosition.website_url}
                  >
                    <i className="fa fa-link"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>الگو صفحه</td>
                <td>
                  {reportPosition.pattern_url == "0" ? (
                    <span>مستقل</span>
                  ) : (
                    <div dir="ltr" className="text-left ">
                      {reportPosition.pattern_url}
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td>اندازه</td>
                <td>
                  <span>ارتفاع = </span>
                  <span>
                    {helperNumbers.toPersianNum(
                      reportPosition.size.split("-")[1]
                    )}
                  </span>
                  <span className="px-3">عرض = </span>
                  <span>
                    {helperNumbers.toPersianNum(
                      reportPosition.size.split("-")[0]
                    )}
                  </span>
                </td>
              </tr>
              <tr>
                <td>تعداد بنر</td>
                <td>{helperNumbers.toPersianNum(reportPosition.count)}</td>
              </tr>
              <tr>
                <td>قیمت پایه جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        reportPosition.base_price
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>قیمت جایگاه یک بنر در یک شبانه روز</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(reportPosition.price)
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>حق نمایش دهنده </td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        reportPosition.publisher_right
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>کمیسیون هایلات</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        reportPosition.hilite_commission
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>امتیاز</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        reportPosition.score_alternative
                      )
                    )}
                  </span>
                </td>
              </tr>

              <tr>
                <td>وضعیت</td>
                <td>
                  <span
                    className={` badge badge-${getBadgeTypeClassStatePosition(
                      reportPosition.state
                    )} `}
                  >
                    {reportPosition.state}
                  </span>
                </td>
              </tr>

              <tr>
                <td>حالت</td>
                <td>
                  <div dir="ltr">
                    {reportPosition.active ? (
                      <span className="badge badge-success">فعال</span>
                    ) : (
                      <span className="badge badge-danger">غیرفعال</span>
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const getReportPosition = () => {
    let tagHtmlID = document.querySelector("#tag-html-id").value;
    if (!tagHtmlID.includes("hilite-position-")) {
      setMessage({
        type_class: "alert alert-danger",
        text: "تگ   id  html جایگاه نامعتبر است.  ",
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    const tagHtmlIDNumber = tagHtmlID.replace("hilite-position-", "");
    if (!Number.isInteger(parseInt(tagHtmlIDNumber))) {
      setMessage({
        type_class: "alert alert-danger",
        text: "تگ id  html جایگاه نامعتبر است.",
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }

    setReportPosition({
      campaign_IDS_pending: [
        { end_date: "2022/10/05", start_date: "2022/10/01" },
        { end_date: "2022/11/15", start_date: "2022/11/10" },
        { end_date: "2022/12/15", start_date: "2022/12/02" },
      ],
      campaign_IDS_active: [],
      campaign_IDS_active_alternative: [
        { end_date: "2022/10/30", start_date: "2022/10/25" },
        { end_date: "2022/12/20", start_date: "2022/12/15" },
      ],
      campaign_IDS_pending_alternative: [],
      id: "2",
      page_id: "12",
      pattern_url: "/",
      website_url: "https://senfnews.com",
      size: "970-90",
      count: "3",
      base_price: "6000",
      price: "2000",
      publisher_right: "1800",
      hilite_commission: "200",
      score_alternative: "2000",
      state: "تایید نهایی",
      active: true,
    });
  };

  return (
    <>
      <Sidebar activeItem="report-position" />

      <div className="content-wrapper">
        <TitleBar title="گزارش جایگاه" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <form
                className="d-flex align-items-end"
                onSubmit={(e) => {
                  e.preventDefault();
                  getReportPosition();
                }}
              >
                <div className="form-group flex-grow-1">
                  <label>تگ شناسه html جایگاه</label>
                  <span dir="ltr">( hilite-position- )</span>
                  <input
                    type="text"
                    className="form-control"
                    id="tag-html-id"
                    placeholder="تگ شناسه html جایگاه"
                    required
                  />
                </div>
                <div className="form-group pr-2">
                  <button className="btn btn-primary" id="show-information">
                    نمایش گزارش جایگاه
                  </button>
                </div>
              </form>
              {reportPosition && generateTagHtmlReportPosition()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
